/*
 * Created on Wed Nov 01 2023 4:27:51 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
import { DomainError } from "../domains/config/domainFallbacks.jsx";
import { DYNAMIC_TEMPLATE_DOMAINS, DOMAIN_TYPES } from "../domains/config/domainTypes";
import { getDomainColors, getDomainLabels } from "../domains/config/domainPresentation";
import { getDomainConfig } from "../domains/config/domainRuntimeConfig.jsx";
import DynamicTemplatePage from "../template/DynamicTemplatePage.jsx";

export { DOMAIN_TYPES } from "../domains/config/domainTypes";
export { getDomainColors, getDomainLabels } from "../domains/config/domainPresentation";
export {
  DomainError,
  DomainLoading,
  MainContent,
  NotAuthorized
} from "../domains/config/domainFallbacks.jsx";
export { DOMAIN_CONFIG } from "../domains/config/domainRuntimeConfig.jsx";
export {
  EducationTemplate,
  FlexTemplate,
  getTemplateByDomain,
  InstitutionTemplate,
  RetailTemplate,
  WaasTemplate
} from "../domains/config/domainShellTemplates.jsx";

export const getPageTemplateByDomain = (domainType) => {
  if (!domainType) return DomainError;
  const domainConfig = getDomainConfig(domainType);
  return domainConfig?.pageTemplate || DomainError;
};

export const getCartByDomain = (domainType) => {
  if (!domainType) return null;
  const domainConfig = getDomainConfig(domainType);
  return domainConfig?.cartTemplate || null;
};

export const getHeaderByDomain = (domainType, runtimeContext) => {
  if (!domainType) return () => null;
  const domainConfig = getDomainConfig(domainType, runtimeContext);
  return domainConfig?.header || (() => null);
};

export const getFooterByDomain = (domainType, runtimeContext) => {
  if (!domainType) return () => null;
  const domainConfig = getDomainConfig(domainType, runtimeContext);
  return domainConfig?.footer || (() => null);
};

export const getUserRoleByDomain = (domainType) => {
  if (!domainType) return null;
  const domainConfig = getDomainConfig(domainType);
  return domainConfig?.userRole || null;
};

export const getNavListByDomain = (domainType) => {
  if (!domainType) return null;
  const domainConfig = getDomainConfig(domainType);
  return domainConfig?.navList || null;
};

export const getDomainColorsByType = (domainType) => getDomainColors(domainType);

export const getDomainLabelsByType = (domainType) => getDomainLabels(domainType);

export const getPageTemplate = (domainType) => {
  if (!domainType || !DOMAIN_TYPES[domainType]) return DomainError;

  const domainConfig = getDomainConfig(domainType);
  const pageTemplate = domainConfig?.pageTemplate;
  if (!pageTemplate) return DomainError;

  if (DYNAMIC_TEMPLATE_DOMAINS.includes(domainType)) {
    return () => (
      <DynamicTemplatePage
        domainType={domainType}
        fallbackComponent={pageTemplate}
        pageKey="home"
        route="/"
      />
    );
  }

  if (typeof pageTemplate === "object" && pageTemplate !== null) {
    if (Object.keys(pageTemplate).length === 0) return DomainError;
    if (pageTemplate.$$typeof || pageTemplate.prototype?.isReactComponent) return pageTemplate;
  }

  if (typeof pageTemplate === "function") return pageTemplate;

  return DomainError;
};
